// extracted by mini-css-extract-plugin
module.exports = {"card":"SearchPodcasts_card__aDILz","waveAnimation":"SearchPodcasts_waveAnimation__lH2MV","marquee":"SearchPodcasts_marquee__XwF3k"};